import React from "react";
import Image from "../../../../assets/img/ShiproneLogo.png";

const StartThread = ({ handleCreateThread }) => {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <div
        className="w-2/3 h-2/3 bg-center bg-opacity-25 flex justify-center items-center space-y-2"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(" +
            Image +
            ")",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="text-center space-y-2">
          <div>
            <h4 className="text-[15px] leading-7 tracking-tight font-bold text-[#1E293B] ">
              No Thread Started yet
            </h4>
            <p className="text-[15px] leading-7 tracking-tight text-[#1E293B]">
              Start a New Thread to Chat with the Stakeholders of this Booking.
            </p>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleCreateThread();
            }}
            className="btn bg-[--bg-color-500] hover:bg-[--bg-color-700] text-white text-sm leading-5 font-medium mt-[3px]"
          >
            Start A Thread
          </button>
        </div>
      </div>
    </div>
  );
};

export default StartThread;
